<template>
  <div class="faq-kartu-prakerja">
    <FaqHeader title="Pertanyaan tentang Prakerja Bukalapak" />
    <div class="content">
      <div v-infinite-scroll="fetchMoreFaq" :infinite-scroll-disabled="isAllFaqLoaded" :infinite-scroll-distance="10">
        <div v-for="(faq, idx) in getList" :key="idx" class="mb-16">
          <FaqCard :id="faq.id" :title="faq.title" :summary="faq.summary" :slug="faq.slug" data-testid="faq-card" />
        </div>
        <div v-if="getIsLoading" class="flex justify-center">
          <BlSpinnerAv data-testid="faq-loader" />
        </div>
      </div>
    </div>
    <FaqFooter />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import FaqHeader from '../components/FaqHeader/FaqHeader.vue';
import FaqFooter from '../components/FaqFooter/FaqFooter.vue';
import FaqCard from '../components/FaqCard/FaqCard.vue';
import infiniteScroll from 'vue-infinite-scroll';
import {BlSpinnerAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'PrakerjaFaqPage',
  directives: {infiniteScroll},
  components: {
    FaqHeader,
    FaqFooter,
    FaqCard,
    BlSpinnerAv,
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        limit: 10,
        total: 0,
      },
    };
  },
  computed: {
    ...mapGetters('faqs', ['getList', 'getIsLoading', 'getMeta']),
    offset() {
      return (this.pagination.currentPage - 1) * this.pagination.limit;
    },
    isAllFaqLoaded() {
      return this.getList.length === this.pagination.total;
    },
  },
  watch: {
    getMeta: {
      handler(val) {
        this.pagination.total = val.total;
      },
      deep: true,
    },
  },
  mounted() {
    this.$store.dispatch('faqs/fetchFaqs', {offset: this.offset, limit: this.pagination.limit, platform: 'mweb'});
  },
  methods: {
    handlePageChange(newPage) {
      this.pagination.currentPage = newPage;
      this.$store.dispatch('faqs/fetchFaqs', {offset: this.offset, limit: this.pagination.limit});
    },
    fetchMoreFaq() {
      if (this.getList.length < this.pagination.total) {
        this.pagination.currentPage += 1;
        this.$store.dispatch('faqs/fetchFaqs', {offset: this.offset, limit: this.pagination.limit, platform: 'mweb'});
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: calc(100vh - 220px);
  padding: 16px;
}
</style>
